import { IPatientAppointmentModel } from "@/Appointments/Models/UI/IPatientAppointmentModel";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { MultiDateSelector } from "@/Common/Components/Inputs/MultiDateSelector";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { QuestionnairePopupController } from "@/Common/Components/Questionnaire/QuestionnairePopupController";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { PatientAppointmentListItem } from "@/Common/Models/Appointments/PatientAppointmentListItem";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ComboAppointmentWarningPopup } from "../ComboAppointmentWarningPopup";
import { AppointmentEditPopup } from "./AppointmentEditPopup";

import styles from "./AppointmentView.module.scss";

interface IPatientHistoryAppointmentProps {
    Model: IPatientAppointmentModel;
}

class AppointmentView extends React.Component<IPatientHistoryAppointmentProps, never> {
    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public componentDidMount(): void {
        window.setTimeout(() => {
            const operation = new LocalEvent(LocalPatientOperations.History.Appointment_LoadPatientAppointment);
            LocalEventDispatcher.dispatch(operation);
        }, 5);

        $(window).trigger("resize");
    }

    public componentWillUnMount(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        const model = this.props.Model;
        const showDetails = model.get("ShowDetails");
        const questionnaire = model.get("QuestionnaireStatusInfo");

        return (
            <div id="apptview" className="medical-summary-container">
                <div className="tb medical-summary">
                    {showDetails && model.get("OpenModifyPopup") &&
                        <AppointmentEditPopup Model={this.props.Model} />
                    }

                    {showDetails && model.get("IsComboAppointmentChangePopupVisible") && (
                        <ComboAppointmentWarningPopup
                            OkClickedTargetOperation={LocalPatientOperations.History.Appointment_ConfirmGroupStateEdit}
                            CancelClickTargetOperation={LocalPatientOperations.History.Appointment_CancelModifyAppointment}
                        />
                    )}

                    {questionnaire && model.get("ShowQuestionnaire") && (
                        <QuestionnairePopupController
                            questionnaire={questionnaire}
                            onClose={() => sessionStore.dispatch(LocalPatientOperations.History.Appointment_ShowQuestionnaire, { showQuestionnaire: false })}
                            onSubmitted={result => sessionStore.dispatch(LocalPatientOperations.History.Appointment_OnQuestionnaireSubmitted, { result })}
                        />
                    )}

                    {this.leftSide(model)}
                    {showDetails && this.rightSide(model)}
                    {!showDetails && this.renderEmptyRightSide()}
                </div>
            </div>
        );
    }

    private leftSide(model: IPatientAppointmentModel): JSX.Element {
        var toggleIconCss = "toggle-icon2";
        if (this.props.Model.get("ShowOnlyCurrent")) {
            toggleIconCss += " active";
        }

        return (
            <div className="fxheight tbc full-border left-primary">
                <div className="note-search">
                    <div className="header" />
                    <div className="search-field">
                        <div className="gf">
                            <span className="glyphicon glyphicon-search" />
                        </div>
                        <TextboxControl debounceMs={400} value={model.get("SearchText")} className="fullWidth" operation={LocalPatientOperations.History.Appointment_SearchText} placeholder={cacheStore.GetString("SearchLabel")} />
                    </div>
                    {model.get("IsCriteriaExpanded") === true && (
                        <div>
                            <div style={{ marginTop: "10px" }}>
                                <MultiDateSelector
                                    id="doc_search_date_selector"
                                    fullWidth={true}
                                    fromMyleOperation={LocalPatientOperations.History.Appointment_FromDateChanged}
                                    toMyleOperation={LocalPatientOperations.History.Appointment_ToDateChanged}
                                    fromSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                    toSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                    from={model.get("DateFrom")}
                                    to={model.get("DateTo")}
                                />
                            </div>
                            {model.get("Sites").count() > 1 && (
                                <select onChange={this.OnSiteSelectedChange.bind(this)} className="form-control myle-control" value={model.get("SelectedSiteId")}>
                                    {model.get("Sites").map((site: SitesModel, idx: number) => (
                                        <option key={idx + "____site"} value={site.Model.Id}>{site.Model.ClinicalName}</option>
                                    ))}
                                </select>
                            )}
                        </div>
                    )}

                    <div className="clearfix" style={{ marginTop: "15px" }}>
                        <span style={{ marginRight: "7px" }} className={toggleIconCss} onClick={this.toggleDisplayMode.bind(this)} />

                        {model.get("IsCriteriaExpanded") === true && (
                            <div className="pull-right">
                                {!model.get("AppointmentList").isEmpty() && (
                                    <div style={{ display: "inline" }}>
                                        <a style={{ marginRight: "5px" }} onClick={this.onPrintHistoryClick.bind(this)}>{cacheStore.GetString("PrintLabel")}</a>
                                        <span>{" | "}</span>
                                    </div>
                                )}
                                <a style={{ marginLeft: "5px" }} onClick={this.ShowCriteria.bind(this)}>[-]{cacheStore.GetString("CriteriaLabel")}</a>
                            </div>
                        )}

                        {model.get("IsCriteriaExpanded") === false && (
                            <div className="pull-right">
                                {!model.get("AppointmentList").isEmpty() && (
                                    <div style={{ display: "inline" }}>
                                        <a style={{ marginRight: "5px" }} onClick={this.onPrintHistoryClick.bind(this)}>{cacheStore.GetString("PrintLabel")}</a>
                                        <span>{" | "}</span>
                                    </div>
                                )}
                                <a style={{ marginLeft: "5px" }} onClick={this.ShowCriteria.bind(this)}>[+]{cacheStore.GetString("CriteriaLabel")}</a>
                            </div>
                        )}
                    </div>
                </div>
                {this.appointmentList(model)}
            </div>
        );
    }

    private appointmentList(model: IPatientAppointmentModel): JSX.Element {
        var appointmentList = model.get("AppointmentList");
        var appointmentRender = appointmentList.map((appointment: PatientAppointmentListItem, idx: number) => {
            let appointmentDescription = cacheStore.GetAppointmentDescription(appointment.Model.Subject, appointment.Model.ServiceDefinitionId, appointment.Model.ComboId);

            if (cacheStore.GetLookupById(appointment.Model.StateId).LookupCode === "CANCELED" || cacheStore.GetLookupById(appointment.Model.StateId).LookupCode === "CANCELLED BY PATIENT" || cacheStore.GetLookupById(appointment.Model.StateId).LookupCode === "NOSHOW") {
                return (
                    <div className="pointer" key={"__a" + idx} onClick={this.setSelectedAppointment.bind(this, appointment)}>
                        <div className="med-note">
                            <div className="tb">
                                <div className="tbc" title={appointmentDescription}>
                                    <p className="ellipsis" style={{ color: "red" }}>
                                        <strong>{appointmentDescription}
                                        </strong>
                                    </p>
                                    <p style={{ color: "red" }}><span>{appointment.Model.StartTimeHour} - {appointment.Model.EndTimeHour}</span></p>
                                    {cacheStore.ClinicSettings.EnableCanadianTriageAndAcuityScore && (
                                        <p style={{ color: "red" }}>
                                            <span><label className="form-label">{cacheStore.GetString("TriageLabel")}</label>:</span>
                                            <span className={styles.leftPadding}>{appointment.Model.CanadianTriageAndAcuityScore}</span>
                                        </p>
                                    )}
                                    <p style={{ color: "red" }}><span>{appointment.Model.With}</span></p>
                                </div>
                                <div className="tbc text-right">
                                    <p style={{ color: "red" }}><span>{appointment.Model.StartTimeDateList}</span></p>
                                    {appointment.Model.IsFuturAppointment === true && (
                                        <ul className="clearfix circles pull-right" style={{ paddingTop: "5px" }}>
                                            <span className="circle" style={{ width: "15px", height: "15px", backgroundColor: "red" }}><i /></span>
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
            else {
                return (
                    <div className="pointer" key={"__a" + idx} onClick={this.setSelectedAppointment.bind(this, appointment)}>
                        <div className="med-note">
                            <div className="tb">
                                <div className="tbc" title={appointmentDescription}>
                                    <p className="ellipsis"><strong>{appointmentDescription}</strong></p>
                                    <p><span>{appointment.Model.StartTimeHour} - {appointment.Model.EndTimeHour}</span></p>
                                    {cacheStore.ClinicSettings.EnableCanadianTriageAndAcuityScore && (
                                        <p>
                                            <span><label className="form-label">{cacheStore.GetString("TriageLabel")}</label>:</span>
                                            <span className={styles.leftPadding}>{appointment.Model.CanadianTriageAndAcuityScore}</span>
                                        </p>
                                    )}
                                    <p><span>{appointment.Model.With}</span></p>
                                </div>
                                <div className="tbc text-right">
                                    <p><span>{appointment.Model.StartTimeDateList}</span></p>
                                    {appointment.Model.IsFuturAppointment === true && (
                                        <ul className="clearfix circles pull-right" style={{ paddingTop: "5px" }}>
                                            <span className="circle" style={{ width: "15px", height: "15px" }}><i /></span>
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        });

        return (
            <div data-hvar="40" className="note-collection scrollable">
                {appointmentRender}
            </div>
        );
    }

    private rightSide(model: IPatientAppointmentModel): JSX.Element {
        const notifyPatientCheckbox = cacheStore.ClinicSettings_Portal.EnablePortalNotifications ? this.renderPatientNotificationCheckbox(model) : null;
        const questionnaireStatusInfo = model.get("QuestionnaireStatusInfo");
        const serviceDescription = cacheStore.GetAppointmentServiceDescription(model.get("ServiceDefinitionId"), model.get("ComboId"));

        return (
            <div className="tbc right-primary">
                <div className="summary-container">

                    <div className="banner" style={{ height: "68px" }}>
                        <label>{cacheStore.GetString("AppointmentDetailsLabel")}</label>
                        <div className="clearfix" style={{ padding: "7px 10px 0 0" }}>
                            <div className="pull-left inline-block">
                                <h3 className="thin-font no-margin" title={model.get("Subject")}>{this.limitDescriptionText(model.get("Subject"), 80)}
                                </h3>
                            </div>
                            <div className="pull-right">
                                <a onClick={this.onPrintClick.bind(this)}>{cacheStore.GetString("PrintLabelLabel")}</a>
                                {this.renderPrintCertificate()}
                            </div>
                        </div>
                    </div>

                    <div data-hvar="60" className="myle-doc-tb main-content myle-form no-x-overflow scrollable documents">
                        {this.renderRightSideRow("SubjectLabel", model.get("Subject"))}
                        {this.renderRightSideRow("ServiceLabel", serviceDescription)}
                        {cacheStore.ClinicSettings.EnableCovidQuestionnaire &&
                            this.renderRightSideRow(
                                "QuestionnaireLabel",
                                "",
                                questionnaireStatusInfo && questionnaireStatusInfo.renderLink(
                                    () =>
                                        this.showQuestionnaire(),
                                    model.get("StartDateForPrint"),
                                    model.get("StateId"),
                                    patientStore.getCurrentPatientContactId()
                                )
                            )
                        }
                        {this.renderRightSideRow("SitesLabel", model.get("SiteName"))}
                        {cacheStore.ClinicSettings.EnableCanadianTriageAndAcuityScore &&
                            this.renderRightSideRow("TriageLabel", model.get("CanadianTriageAndAcuityScore"))
                        }
                        {this.renderRightSideRow("WithLabel", model.get("With"))}
                        {this.renderRightSideRow("RoomLabel", model.get("Room"))}
                        {this.renderRightSideRow("StartTimeLabel", model.get("StartTime"), notifyPatientCheckbox)}
                        {this.renderRightSideRow("EndTimeLabel", model.get("EndTime"))}
                        {this.renderRightSideRow("StateLabel", model.get("StateName"))}
                        {this.renderRightSideRow("PaidLabel", cacheStore.GetString(model.get("IsPaid") ? "YesLabel" : "NoLabel"))}
                        {cacheStore.ClinicSettings.EnableIsTeleconsultationCheckbox &&
                            this.renderRightSideRow("TeleconsultationLabel", cacheStore.GetString(model.get("IsTeleconsultation") ? "YesLabel" : "NoLabel"))
                        }
                        {this.renderRightSideRow("NotesLabel", JSXHelper.BreakStringIntoParagraphs(model.get("Notes")))}
                    </div>
                    {!model.get("IsReadOnly") && (
                        <div className="meta-footer">
                            <ButtonControl
                                onClick={() => sessionStore.dispatch(LocalPatientOperations.History.Appointment_ModifySelectedAppointment)}
                                label={cacheStore.GetString("ModifyLabel")}
                                className="btn btn-primary pull-right"
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private renderPatientNotificationCheckbox(model: IPatientAppointmentModel): JSX.Element {
        return (
            <div style={{ marginLeft: "20px", display: "inline" }}>
                <CheckboxControl
                    disabled={true}
                    checked={model.get("NotifyPatient")}
                    label={cacheStore.GetString("NotifyPatientLabel")}
                />
            </div>
        );
    }

    private renderPrintCertificate(): JSX.Element {
        const cancelledStateCodes = ["NOSHOW", "CANCELED", "CANCELLED BY PATIENT"];
        if (cancelledStateCodes.any(x => x === this.props.Model.get("SelectedAppointmentStateCode")))
            return null;

        return (
            <div style={{ display: "inline" }}>
                <span>{" | "}</span>
                <a onClick={() => this.onPrintCertificate()}>{cacheStore.GetString("PrintCertificateLabel")}</a>
            </div>
        );
    }

    private renderRightSideRow(propertyLabelName: string, propertyValue: React.ReactNode, additionalElements: JSX.Element = null): JSX.Element {
        return (
            <div className="row">
                <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                    <label className="form-label">{cacheStore.GetString(propertyLabelName)}</label>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 form-field-answer">
                    <strong>{propertyValue}</strong>
                    {additionalElements}
                </div>
            </div>
        );
    }

    private renderEmptyRightSide(): JSX.Element {
        return (
            <div className="tbc right-primary">
                <div className="scrollable">
                    <div className="summary-container no-border" />
                </div>
            </div>
        );
    }

    private limitDescriptionText(str: string, maxLength: number = 120): string {
        if (str == null)
            return "";

        if (str.length > maxLength)
            return str.slice(0, maxLength) + "...";

        return str;
    }

    private toggleDisplayMode(): void {
        LocalEvent.Dispatch(LocalPatientOperations.History.Appointment_ShowOnlyCurrent);
    }

    private onPrintHistoryClick(): void {
        LocalEvent.Dispatch(LocalPatientOperations.History.Appointment_OnPrintHistoryClick);
    }

    private onPrintClick(): void {
        LocalEvent.Dispatch(LocalPatientOperations.History.Appointment_OnPrintLabelClick);
    }

    public ShowCriteria(): void {
        LocalEvent.Dispatch(LocalPatientOperations.History.Appointment_CriteriaClick);
    }

    private OnSiteSelectedChange(e: React.ChangeEvent<HTMLSelectElement>): void {
        var operation = new LocalEvent(LocalPatientOperations.History.Appointment_OnSiteChange);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    public setSelectedAppointment(appointment: PatientAppointmentListItem): void {
        var operation = new LocalEvent(LocalPatientOperations.History.Appointment_ShowSelectedAppointment);
        operation.AddItem("appointment", appointment);
        LocalEventDispatcher.dispatch(operation);
    }

    private showQuestionnaire(): void {
        sessionStore.dispatch(LocalPatientOperations.History.Appointment_ShowQuestionnaire, { showQuestionnaire: true });
    }

    private onPrintCertificate(): void {
        sessionStore.dispatch(LocalPatientOperations.History.Appointment_PrintCertificate);
    }
}

export { AppointmentView, IPatientHistoryAppointmentProps };
